import { render, staticRenderFns } from "./modif_groups.vue?vue&type=template&id=031bf739&scoped=true&"
import script from "./modif_groups.vue?vue&type=script&lang=js&"
export * from "./modif_groups.vue?vue&type=script&lang=js&"
import style0 from "./modif_groups.vue?vue&type=style&index=0&id=031bf739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031bf739",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031bf739')) {
      api.createRecord('031bf739', component.options)
    } else {
      api.reload('031bf739', component.options)
    }
    module.hot.accept("./modif_groups.vue?vue&type=template&id=031bf739&scoped=true&", function () {
      api.rerender('031bf739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/modif_groups.vue"
export default component.exports